<template>
  <v-autocomplete
    v-model="selected"
    append-icon=""
    prepend-inner-icon="search"
    :items="searchItems"
    :loading="searchLoading"
    placeholder="Search"
    clearable
  >
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item"></v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-avatar v-if="data.item.value.pathName === 'Employee'">
          <v-img :src="getAvatar(data.item.avatar, data.item.text)"></v-img>
        </v-list-item-avatar>
        <v-list-item-content v-if="data.item.value.pathName === 'Employee'">
          <v-list-item-title>
            {{ data.item.text.split(' * ')[0] }}
            <v-chip 
              v-if="data.item.inactive" 
              color="error" 
              class="text-uppercase"
              x-small
            >Inactive</v-chip>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.subtext }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <!-- Non Employee Results -->
        <v-list-item-content v-else>
          <v-list-item-title v-html="data.item.text">
          </v-list-item-title>
          <v-list-item-subtitle v-html="data.item.subtext">
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
  import User from '@/mixins/User'
  
  export default {
    name: 'search',
    Mixins: [ User ],
    data () {
      return {
        searchLoading: true,
        selected: null
      }
    },
    watch: {
      selected (newVal) {
        this.$router.push({
          name: newVal.pathName,
          params: { id: newVal.id }
        })
      },
      user (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    },
    created () {
      if (this.userIsAdmin) {
        this.init()
      } else {
        this.searchLoading = false
      }
    },
    methods: {
      init () {
        const employees = this.$store.dispatch('getRecords', {
          table: 'Employees',
          view: 'All Employees',
          dispatch: 'setEmployees'
        })
        const sessions = this.$store.dispatch('getRecords', {
          table: 'Sessions',
          view: 'All Sessions',
          dispatch: 'setSessions'
        })
        const curriculums = this.$store.dispatch('getRecords', {
          table: 'Curriculums',
          view: 'All Curriculums',
          dispatch: 'setCurriculums'
        })
        Promise.all([employees, sessions, curriculums])
        .then(() => {
          return this.searchLoading = false
        })
      },
      getAvatar (avatar, name) {
        if (!avatar || avatar === undefined) {
          const color = this.$vuetify.theme.themes.light.primary.split('#')[1]
          return `https://ui-avatars.com/api/?name=${name}&background=${color}&color=fff&rounded=true`
        } else {
          return avatar
        }
      },
    },
    computed: {
      employees () {
        return this.$store.getters.getEmployees
      },
      curriculums () {
        return this.$store.getters.getCurriculums
      },
      sessions () {
        return this.$store.getters.getSessions
      },
      searchItems () {
        let items = []
        const mappedCurriculums = this.curriculums.map(c => {
          return {
            text: c.fields.Name,
            subtext: c.fields.Name,
            value: {
              pathName: 'Curriculum',
              id: c.id
            },
          }
        })
        items.push({ header: 'Curriculums' })
        items = items.concat(mappedCurriculums)
        items.push({ divider: true })
        const mappedSessions = this.sessions.map(s => {
          return {
            text: s.fields.Name,
            subtext: s.fields['Curriculum Name'] ? 
                     s.fields['Curriculum Name'][0] : null,
            value: {
              pathName: 'Session',
              id: s.id
            },
          }
        })
        items.push({ header: 'Sessions' })
        items = items.concat(mappedSessions)
        items.push({ divider: true })
        const mappedEmployees = this.employees.map(e => {
          return {
            // add email to item.text to make it searchable for the user
            // email gets stripped from the select dropdown on render
            text: e.fields.Name + ' * ' + e.fields.Email,
            subtext: `${e.fields.Title} • ${e.fields.Department}`,
            inactive: e.fields.Status === 'Inactive',
            avatar: e.fields.Avatar ? 
                    e.fields.Avatar[0].url :
                    null,
            value: {
              pathName: 'Employee',
              id: e.id
            }
          }
        })
        items.push({ header: 'Employees' })
        items = items.concat(mappedEmployees)
        
        return items
      }
    }
  }
</script>
